/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface PatchedRiskCategoryWrite
 */
export interface PatchedRiskCategoryWrite {
  /**
   *
   * @type {string}
   * @memberof PatchedRiskCategoryWrite
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof PatchedRiskCategoryWrite
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof PatchedRiskCategoryWrite
   */
  parent?: number | null;
  /**
   *
   * @type {string}
   * @memberof PatchedRiskCategoryWrite
   */
  description?: string | null;
  /**
   *
   * @type {Array<{ [key: string]: any; }>}
   * @memberof PatchedRiskCategoryWrite
   */
  children?: Array<{ [key: string]: any }>;
}

/**
 * Check if a given object implements the PatchedRiskCategoryWrite interface.
 */
export function instanceOfPatchedRiskCategoryWrite(value: object): value is PatchedRiskCategoryWrite {
  return true;
}

export function PatchedRiskCategoryWriteFromJSON(json: any): PatchedRiskCategoryWrite {
  return PatchedRiskCategoryWriteFromJSONTyped(json, false);
}

export function PatchedRiskCategoryWriteFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PatchedRiskCategoryWrite {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'] == null ? undefined : json['name'],
    title: json['title'] == null ? undefined : json['title'],
    parent: json['parent'] == null ? undefined : json['parent'],
    description: json['description'] == null ? undefined : json['description'],
    children: json['children'] == null ? undefined : json['children'],
  };
}

export function PatchedRiskCategoryWriteToJSON(value?: PatchedRiskCategoryWrite | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    title: value['title'],
    parent: value['parent'],
    description: value['description'],
    children: value['children'],
  };
}
